import dayjs from 'dayjslib';
import utc from 'dayjslib/plugin/utc';

dayjs.extend(utc);

export default dayjs;
